import {getSourcesData} from '../helpers/sources';
import {request} from '../helpers/request'
let config = require('config');

function updateRequestStatus (){
  this.setState({requestStatus: false})
}

export function getSourceNameAndCc(sourceName, context) {
  request(`${config.default.api}/sources/`, 'GET', null, (responseData, statusCode) => {
    if (statusCode == 200) {
      const source = responseData.sources.find(
        (source) => {return source.name === sourceName}
      );

      context.setState({
        sourceFullName: (sourceName == 'universal') ? 'Search Policies' : `${source.full_name} ${source.category}`,
        sourceCC: source.cc
      })
    }
  });
}



// WEBPACK FOOTER //
// ./src/helpers/getSourceData.js